
import React, { useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useMounted from '../../../hooks/useMounted';

import SimpleReactValidator from 'simple-react-validator';
import { post } from '../../../helpers/api_helper';
import { POST_GET_UNITS_DETAIL, POST_ADD_EDIT_UNITS } from '../../../helpers/url_helper';
import { toast } from 'react-toastify';
import Loader from '../../../components/Loader';
import { useTranslation } from 'react-i18next';

const Setting = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [isLoader, setLoader] = useState(0);

    const simpleValidator = useRef(new SimpleReactValidator());
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [form_inputs, setInputs] = useState({ unitId: 0, unitName: '', unitCode : '' });
    const [, forceUpdate] = useState();

    const { id } = useParams()

    useMounted(() => {
        async function get_detaile() {
            if (id) {
                var res_data = await post(POST_GET_UNITS_DETAIL, { 'unitId': id });
                if (res_data.status) {
                    setInputs(res_data.data.detail);
                } else {
                    toast.error(res_data.message);
                    navigate("/dashboard");
                }
            }
            setLoader(1)
        }

        get_detaile();
    }, [navigate])

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_ADD_EDIT_UNITS, form_inputs, {});
            if (res_data.status) {
                toast(res_data.message);
                navigate("/units");
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // input text change handler
    const handleInputChange = (event) => {
        event.persist();
        if(event.target.name === 'unitCode'){
            const value = event.target.value.trim();
            setInputs(inputs => ({ ...inputs, [event.target.name]: value.toUpperCase() }));
        }else{
            setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
        }
    }

    if (!isLoader) {
        return (<Loader />);
    }
    return (
        <>
            <div className='row'>
                <div className="col-md-6">
                    <div className="card mb-4">
                        <h5 className="card-header">{t('units.form.title')}</h5>
                        <div className="card-body">
                            <form className="av-invalid" onSubmit={handleSubmit}>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">{t('units.form.unitName')} *</label>
                                    <input name="unitName" value={form_inputs.unitName} onChange={handleInputChange} className="form-control" placeholder={t('units.placeholder.unitName')} type="text" />
                                    {simpleValidator.current.message('name', form_inputs.unitName, 'required' , {messages : {
                                        required : t('units.formError.unitNameRequired')
                                    }})}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">{t('units.form.unitCode')} *</label>
                                    <input name="unitCode" value={form_inputs.unitCode} onChange={handleInputChange} className="form-control" placeholder={t('units.placeholder.unitCode')} type="text" maxLength={6} />
                                    {simpleValidator.current.message('code', form_inputs.unitCode, 'required', {messages : {
                                        required : t('units.formError.unitCodeRequired')
                                    }})}
                                </div>
                               
                                <div className='text-center'>
                                    <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2">
                                        {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} {t('save')}
                                    </button>
                                    <Link to="/units" className="btn btn-danger ms-3"> {t('cancel')}</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Setting;